const RealEstatesWeb = require('./lib/RealEstatesWeb');
const { validateCustomParams } = require('./src/realestates-web/utils/validations/index');

module.exports = RealEstatesWeb;
module.exports.validateCustomParams = validateCustomParams;
